import type { ChatChannelKind } from "Infrastructure/Api/Api";

/**
 * The channel's kind as Stream carries it in the channel's custom data (mirrors the backend's
 * ChatChannelKind; the API itself speaks the enum, this is the channel-data spelling). Keyed by
 * the enum's members, so a value added on one side is missed on the other at compile time.
 */
export const ChannelKind = {
  Direct: "direct",
  Group: "group",
} as const satisfies Record<keyof typeof ChatChannelKind, string>;

export type ChannelKind = (typeof ChannelKind)[keyof typeof ChannelKind];
